import { createEnumTypeguard } from '@/utils/create-enum-typeguard';

import { MobileButtonVariant } from './constants';

export const mobileButtonVariantTypeguard =
  createEnumTypeguard(MobileButtonVariant);
